export const FILE_TYPE = {
  pdf: 1,
  audio: 2,
  video: 3,
  document: 4,
  ppt: 5,
  pps: 6,
  keynote: 7,
  url: 8,
};
